import "./OurCapabilities.module.css";
import Header from "@/reusable_sections/Header";
import CapabilitiesHero from "./sections/CapabilitiesHero";
import Servicedomainscapabilities from "./sections/Servicedomainscapabilities";
import Footer from "@/reusable_sections/Footer";
export default function OurCapabilitiesPage() {
  return <div>
      <Header />
      <CapabilitiesHero />
      <Servicedomainscapabilities />
      <Footer />
    </div>;
}